export default __webpack_public_path__ + "ff2b4822dae28353eda5c71d60ef9bbb.png";